export const DATA_LAKE_COMPATIBLE_CONNECTIONS = ['M3', 'LN'];

export const GENERIC_DATALAKE_QUERY_TEMPLATE = `{    
    "connectionId": "",
    "endpoint": "",
    "body": "",
    "saveAsFile": false
}`;
